'use strict';

function _CardController() {
  this.id = null;
  this.node = null;
  this.declaredClass = null;
  this.extends = [_AccountController, _Paths, _ResponsiveLayout];
  this._hist = null;
  this._errorInitialized = false;
  this._path = window.location.pathname;

  this.init = function () {
    this._super();

    this._productSettings = new ProductSettings(this.presenter);
    this._hist = new History();
    this._hist.replaceUrl('/member/dashboard/home');
  };

  this.initAllReady = function () {
    this._super();
  };
}